export default "__VITE_ASSET__DGoXGIL4__ 480w, __VITE_ASSET__CFkaMzj8__ 768w, __VITE_ASSET__DoI0KFrv__ 1200w, __VITE_ASSET__CHQPe9t8__ 1920w";